import React, { useEffect } from 'react';

import { CookiesPDFUrl } from '@constants/app';

export default () => {

  useEffect(() => {
    window.location.href = CookiesPDFUrl;
  }, []);

  return <></>;
};
